<template>
  <form @submit.prevent="update">
    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
      <!-- <image-input v-model="form.cover" :error="form.errors.cover" class="pb-8 pr-6 w-full lg:w-1/2"
        accept="image/*" label="Cover" /> -->

      <image-input
        :value="form.cover"
        @update-cover="(new_cover) => (form.new_cover = new_cover)"
        :error="form.errors.new_cover"
        class="pb-8 pr-6 w-full lg:w-1/2"
        accept="image/*"
        label="Cover"
      />

      <text-input
        v-model="form.title"
        :error="form.errors.title"
        class="pb-8 pr-6 w-full lg:w-1/2"
        label="Titel"
      />

      <text-input
        v-model="form.isbn"
        :error="form.errors.isbn"
        class="pb-8 pr-6 w-full lg:w-1/2"
        label="ISBN"
      />

      <text-area-input
        rows="5"
        v-model="form.description"
        :error="form.errors.description"
        class="pb-8 pr-6 w-full lg:w-1/2"
        label="Beschrijving"
      />

      <!-- <text-input
        v-model="form.description"
        :error="form.errors.description"
        class="pb-8 pr-6 w-full lg:w-1/2"
        label="Description"
      /> -->

      <div class="pb-8 pr-6 w-full lg:w-1/2">
        <label class="form-label">Genres:</label>
        <Multiselect
          v-model="form.genres"
          :mode="'tags'"
          :searchable="true"
          :create-option="true"
          :options="genres"
        />
        <div v-if="form.errors.genres" class="form-error">
          {{ form.errors.genres }}
        </div>
      </div>

      <div class="pb-8 pr-6 w-full lg:w-1/2">
        <label class="form-label">Categorieën:</label>
        <Multiselect
          v-model="form.categories"
          :mode="'tags'"
          :searchable="true"
          :create-option="true"
          :options="categories"
        />
        <div v-if="form.errors.categories" class="form-error">
          {{ form.errors.categories }}
        </div>
      </div>

      <div class="pb-8 pr-6 w-full lg:w-1/2 md:w-1/2">
        <label class="form-label">Auteur(s):</label>
        <Multiselect
          v-model="form.authors"
          :mode="'tags'"
          :searchable="true"
          :create-option="true"
          :options="authors"
        />
        <div v-if="form.errors.authors" class="form-error">
          {{ form.errors.authors }}
        </div>
      </div>
    </div>

    <!-- <div class="flex flex-wrap -mb-8 -mr-6 p-8">
      <div class="w-full">
        <h2>Copies</h2>
      </div> -->
    <!-- <text-input v-model="form.book_items[0].serial" :error="form.errors.book_items[0].serial" class="pb-8 pr-6 w-full lg:w-1/2" label="Serial" /> -->
    <!-- <text-input v-model="form.book_items[0].serial" :error="form.errors['book_items.0.serial']" class="pb-8 pr-6 w-full lg:w-1/2" label="Serial" /> -->

    <!-- </div> -->

    <div
      class="
        flex
        items-center
        justify-end
        px-8
        py-4
        bg-gray-50
        border-t border-gray-100
      "
    >
      <loading-button
        :loading="form.processing"
        class="btn-indigo"
        type="submit"
        >Boek bijwerken</loading-button
      >
    </div>
  </form>
</template>

<script>
import TextInput from "@/Shared/TextInput";
import TextAreaInput from "@/Shared/TextareaInput";
import LoadingButton from "@/Shared/LoadingButton";
import Multiselect from "@vueform/multiselect";
import ImageInput from "@/Shared/ImageInput";

export default {
  components: {
    LoadingButton,
    ImageInput,
    TextInput,
    TextAreaInput,
    Multiselect,
  },
  props: {
    genres: Array,
    categories: Array,
    authors: Array,
    book: Object,
  },
  remember: "form",
  data() {
    return {
      form: this.$inertia.form({
        isbn: this.book.data.isbn,
        cover: this.book.data.cover,
        new_cover: null,
        title: this.book.data.title,
        description: this.book.data.description,
        genres: this.book.data.genres,
        categories: this.book.data.categories,
        authors: this.book.data.authors,
        _method: "PUT",
      }),
    };
  },
  methods: {
    update() {
      this.form.post(`/books/${this.book.data.id}`);
    },
  },
};
</script>

